/**
 * yd-gestures-sticky: V3 手势段 pin 滚动切换（GSAP ScrollTrigger，本地全局变量）。
 * 源自 web-hand-off gestures-sticky.js：import→window.gsap；删 partials:loaded，补 shopify:section:load。
 * 整组钉住，滚动切手势 0→3（旧条上滑出 is-above / 新条下滑入 is-active）+ 视频 crossfade；
 * 末段背景白→黑沉入紧接的 film。无 GSAP / reduced-motion：顺序全显示、视频停首帧。
 *
 * GSAP 评审优化（2026-06-14）：
 * - onUpdate（每帧滚动回调）内的 .kw-container 查询提到 setup 顶部缓存，避免每帧 DOM 查询。
 * - ScrollTrigger 带 id，shopify:section:unload 时 kill，避免主题编辑器重排后空转。
 */
(function () {
  var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
  function setup(section) {
    if (section.dataset.gestxReady) return;
    section.dataset.gestxReady = '1';
    var sid = section.id ? section.id : 'gestures';
    var body = section.querySelector('.gestx__body');
    var items = [].slice.call(section.querySelectorAll('.gestx__item'));
    var videos = [].slice.call(section.querySelectorAll('.gestx__video'));
    var dots = [].slice.call(section.querySelectorAll('.gestx__dot'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function activate(i) {
      items.forEach(function (it, idx) {
        it.classList.toggle('is-active', idx === i);
        it.classList.toggle('is-above', idx < i);
      });
      videos.forEach(function (v, idx) {
        var on = idx === i;
        v.classList.toggle('is-active', on);
        if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    // 无 GSAP / reduced / 无 body → 降级：顺序全显示，视频停首帧
    if (reduce || !body || !gsap || !ScrollTrigger) {
      section.classList.add('is-static');
      items.forEach(function (it) { it.classList.add('is-active'); });
      videos.forEach(function (v, idx) {
        if (idx === 0) v.classList.add('is-active');
        v.addEventListener('loadeddata', function () { try { v.currentTime = 0; v.pause(); } catch (e) {} });
      });
      return;
    }
    activate(0);
    var cur = 0;
    var inner = section.querySelector('.kw-container');   // 缓存：避免在 onUpdate 每帧查询
    var pinTarget = inner || body;
    ScrollTrigger.create({
      id: 'yd-gestx-' + sid,
      trigger: pinTarget, start: 'center center', end: '+=340%',
      pin: pinTarget, scrub: 0.3, anticipatePin: 1,
      onUpdate: function (self) {
        var p = self.progress, span = 0.82;
        if (p < span) {
          var idx = Math.min(items.length - 1, Math.floor(p / span * items.length));
          if (idx !== cur) { cur = idx; activate(idx); }
        }
        var t = p > span ? (p - span) / (1 - span) : 0;
        var v = Math.round(255 + (6 - 255) * t);
        section.style.backgroundColor = t > 0 ? 'rgb(' + v + ',' + v + ',' + v + ')' : '';
        if (inner) inner.style.opacity = String(1 - t);
      }
    });
  }
  function init() {
    if (window.gsap && window.ScrollTrigger) { gsap = window.gsap; ScrollTrigger = window.ScrollTrigger; gsap.registerPlugin(ScrollTrigger); }
    document.querySelectorAll('[data-gestx]').forEach(setup);
  }
  function cleanup(e) {
    var sec = e && e.target ? e.target : null;
    if (!sec || !window.ScrollTrigger) return;
    // kill 该 section 容器内的 gestx ScrollTrigger（id 前缀匹配 + trigger 落在容器内）
    ScrollTrigger.getAll().forEach(function (st) {
      if (st.vars && typeof st.vars.id === 'string' && st.vars.id.indexOf('yd-gestx-') === 0 && (!st.trigger || sec.contains(st.trigger))) st.kill();
    });
    var g = sec.querySelector('[data-gestx]');
    if (g) delete g.dataset.gestxReady;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', cleanup);
  window.addEventListener('load', function () { init(); if (window.ScrollTrigger) window.ScrollTrigger.refresh(); });
})();
